/**
 * The forecast time window on the client (f11.5).
 *
 * The ONLY place the grid reads whether a month is closed, and it reads the
 * server's `months[].closed` flag. The window is derived server-side from the
 * cycle's closing month (runbook §5.3); the client configures and recomputes
 * nothing here.
 */

import type { ForecastGrid } from '@/api/client';

export type MonthHeader = ForecastGrid['months'][number];

/** The marker a closed month carries: it is now an actual, not a forecast. */
export const ACTUAL_LABEL = 'Actual';

export function isActualMonth(month: Pick<MonthHeader, 'closed'> | undefined): boolean {
  return month?.closed === true;
}

/** "Jul 2026 is closed — Actual". */
export function closedCellTitle(month: MonthHeader, periodYear: number): string {
  return `${month.label} ${periodYear} is closed — ${ACTUAL_LABEL}`;
}
